/**
 * Werbemails an Gäste — Geburtstagsgruß und Wiederkehr-Ansprache.
 *
 * Reine Funktionen, kein React, kein Datenzugriff, keine Rechtsberatung. Was hier
 * steht, ist die Umsetzung dessen, was der Betrieb entschieden hat — und die Riegel,
 * die verhindern, dass eine Mail hinausgeht, die nicht hinausgehen darf.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * WARUM DIESE DATEI SO VIEL PRÜFT, BEVOR SIE ETWAS ERLAUBT
 *
 * Eine Werbe-E-Mail ist in Österreich und Deutschland grundsätzlich nur mit
 * vorheriger EINWILLIGUNG zulässig. Beides sind Umsetzungen desselben Art. 13
 * ePrivacy-Richtlinie, und beide gelten gegenüber Verbrauchern UND Unternehmern —
 * die verbreitete Annahme, im Geschäftsverkehr sei es lockerer, trifft für E-Mail in
 * keinem der beiden Länder zu:
 *
 *   AT — § 174 Abs. 3 TKG 2021: „Die Zusendung einer elektronischen Post —
 *        einschließlich SMS — ist ohne vorherige Einwilligung des Empfängers
 *        unzulässig, wenn die Zusendung zu Zwecken der Direktwerbung erfolgt."
 *        Verwaltungsstrafe bis 50.000 € (§ 188 Abs. 4 Z 28 TKG).
 *   DE — § 7 Abs. 2 Nr. 2 UWG: Werbung unter Verwendung elektronischer Post ohne
 *        vorherige ausdrückliche Einwilligung des Adressaten ist stets eine
 *        unzumutbare Belästigung. Keine Ordnungswidrigkeit, aber abmahnfähig.
 *
 * Für BESTANDSKUNDEN gibt es eine Ausnahme — § 174 Abs. 4 TKG, § 7 Abs. 3 UWG.
 * Sie hat VIER Bedingungen, die KUMULATIV vorliegen müssen (im deutschen Text
 * ausdrücklich, im österreichischen durch „und" zwischen den Ziffern verbunden):
 *
 *   1. die Adresse stammt aus dem Verkauf einer Ware oder Dienstleistung an
 *      diesen Kunden,
 *   2. beworben werden EIGENE ÄHNLICHE Waren oder Dienstleistungen,
 *   3. der Kunde hat nicht widersprochen,
 *   4. auf das Widerspruchsrecht wurde BEI DER ERHEBUNG DER ADRESSE **und** BEI
 *      JEDER VERWENDUNG klar und deutlich hingewiesen, kostenfrei außer den
 *      Übermittlungskosten nach Basistarifen.
 *
 * WIR BAUEN NICHT AUF DIESE AUSNAHME. Zwei Gründe:
 *
 *   ERSTENS liegt Bedingung 4 außerhalb dieser Datenbank. Ob beim Aufnehmen der
 *   Adresse — am Telefon, im Anfrageformular, auf dem Meldeschein — auf den
 *   Widerspruch hingewiesen wurde, weiß nur der Betrieb. Fehlt der Hinweis DAMALS,
 *   ist die Ausnahme unrettbar verloren; nachholen lässt sie sich nicht. Eine
 *   Software, die das aus vier Spalten errät, errät es falsch.
 *
 *   ZWEITENS ist ausgerechnet der Geburtstagsgruß der schwierigste Fall. Dass er
 *   Werbung IST, ist geklärt: der Werbebegriff des Art. 2 lit. a RL 2006/114/EG
 *   erfasst jede Äußerung mit dem Ziel der Absatzförderung, also auch mittelbare,
 *   und die Orientierungshilfe der Datenschutzaufsichtsbehörden zur Direktwerbung
 *   (DSK, 18.02.2022) nennt „Geburtstags- und Weihnachtsmailings" ausdrücklich als
 *   Werbung. Aber er bewirbt keine „ähnlichen Waren oder Dienstleistungen" — er
 *   bewirbt gar nichts. Damit fällt er nach dem Wortlaut durch Bedingung 2 und
 *   damit aus der Ausnahme heraus. Das Ergebnis ist paradox (der harmlose Gruß ist
 *   strenger geregelt als das Angebot), folgt aber aus dem Text, und die Ausnahme
 *   ist eng auszulegen. HÖCHSTRICHTERLICH ENTSCHIEDEN IST DAS NICHT — es ist der
 *   Punkt, an dem ein Betrieb sich beraten lassen sollte, bevor er sich darauf
 *   verlässt.
 *
 * Also: OHNE EINWILLIGUNG GEHT NICHTS. Strenger als das Gesetz in jedem Fall
 * verlangt, und das ist Absicht. Wer die Ausnahme für sich geprüft hat, kann die
 * Einwilligung eintragen; der umgekehrte Weg — erst senden, dann feststellen, dass
 * es keine Ausnahme war — lässt sich nicht rückgängig machen.
 *
 * Unabhängig von der Einwilligung braucht jede Werbemail außerdem:
 *   • einen ABMELDEWEG ohne Kosten und ohne Anmeldung. § 174 Abs. 5 Z 4 TKG
 *     verlangt eine authentische Adresse für die Abbestellung; § 7 Abs. 3 Nr. 4 UWG
 *     den Hinweis bei jeder Verwendung; Art. 7 Abs. 3 DSGVO, dass der Widerruf so
 *     einfach ist wie die Erteilung. Die DSK verlangt zusätzlich, dass der
 *     Widerspruch AUCH FORMLOS möglich bleibt — eine schlichte Antwortmail genügt,
 *     und der Betrieb muss sie beachten. Deshalb gibt es hier auch den Weg von Hand.
 *   • eine ANBIETERKENNZEICHNUNG. AT: §§ 5 und 6 ECG, bei im Firmenbuch
 *     eingetragenen Unternehmen zusätzlich § 14 UGB (Firma, Rechtsform, Sitz,
 *     Firmenbuchnummer, Firmenbuchgericht), sonst § 63 GewO (Name und Standort).
 *     DE: § 6 DDG für kommerzielle Kommunikation — NICHT § 5 DDG, der die
 *     Website-Impressumspflicht regelt — sowie § 37a HGB bzw. § 35a GmbHG für
 *     Geschäftsbriefe, wozu E-Mails zählen.
 *   • einen Absender, der weder in Kopf- noch in Betreffzeile verschleiert ist
 *     (§ 174 Abs. 5 Z 1 TKG, § 6 Abs. 2 DDG).
 *
 * Den Abmeldelink erzwingt `renderGuestMail`: eine Werbemail ohne ihn wird nicht
 * gerendert, statt eine ohne ihn zu verschicken.
 *
 * NOCH NICHT ABGEDECKT — steht im Bericht und gehört geprüft:
 *   • Die ECG-LISTE (§ 7 Abs. 2 ECG, geführt von der RTR). Ein österreichischer
 *     Betrieb hat sie zu beachten; eine Abfrage vor dem Versand findet hier nicht
 *     statt. Bei einem Gast, der ausdrücklich eingewilligt hat, ist der praktische
 *     Fall selten — er ist deshalb nicht ausgeschlossen.
 *   • Der NACHWEIS der Einwilligung muss nach Art. 7 Abs. 1 DSGVO auch ihren
 *     WORTLAUT umfassen. `marketing_consent_source` ist ein Freitextfeld und damit
 *     nur so gut wie das, was hineingeschrieben wird.
 *
 * WAS DIESE DATEI NICHT TUT: entscheiden, ob der Betrieb werben DARF. Das ist eine
 * Rechtsfrage und keine Funktion. Sie sorgt dafür, dass die Entscheidung, die der
 * Betrieb getroffen hat, nachvollziehbar bleibt und nicht versehentlich umgangen wird.
 * ═══════════════════════════════════════════════════════════════════════════
 */

import type { ISODate } from '../data/model'
import { nights } from './dates'
import type { GuestProfile } from './guests'
import { defaultMarketingTemplate, type MailKind, type MailLang } from './mailTemplates'

/* ────────────────────────────────────────────────────────── Datenform */

export type MarketingKind = 'birthday' | 'return'

export const MARKETING_KINDS: MarketingKind[] = ['birthday', 'return']

/** Die Spalten aus Migration 0047. Lokal deklariert wie in `guests.ts`. */
export interface MarketingProfile extends GuestProfile {
  /** Gesetzt, sobald der Gast über den Abmeldelink widersprochen hat. */
  marketing_unsubscribed_at?: string | null
  /** Woher der Widerspruch kam: 'link' (Abmeldelink) oder 'manual'. */
  marketing_unsubscribed_source?: string | null
  /**
   * Der Ausweis des Abmeldelinks. Wie beim Check-in ist der Token die EINZIGE
   * Berechtigung — der Gast hat kein Konto und soll keines brauchen.
   */
  marketing_token?: string | null
}

/* ────────────────────────────────────────────────────── Wer nichts bekommt */

export type MarketingBlock =
  | 'anonymized'
  | 'merged'
  | 'blacklisted'
  | 'no_email'
  | 'unsubscribed'
  | 'no_consent'

/**
 * Alle Gründe, aus denen dieser Gast keine Werbung bekommt — in der Reihenfolge,
 * in der man sie erklären würde.
 *
 * ALLE, nicht nur der erste: der Vermieter soll wissen, dass ein Häkchen bei der
 * Einwilligung nichts ändert, solange keine E-Mail-Adresse da ist. Die Oberfläche
 * zeigt trotzdem nur den ersten an, weil eine Liste von Gründen wie eine Strafe
 * aussieht — aber sie hat die Wahl, und dafür muss sie sie alle kennen.
 *
 * Die Reihenfolge ist nicht beliebig: `anonymized` und `merged` sind endgültig,
 * `blacklisted` ist eine Entscheidung des Betriebs, `unsubscribed` eine des Gastes,
 * und `no_consent` ist der Normalfall, an dem sich etwas ändern lässt.
 */
export function marketingBlocks(guest: MarketingProfile): MarketingBlock[] {
  const out: MarketingBlock[] = []

  // Ein entkernter Datensatz hat keine Person mehr, an die man schreiben könnte —
  // und ein Rest-Postfach anzuschreiben wäre genau die Verarbeitung, die die
  // Anonymisierung beenden sollte.
  if (guest.anonymized_at) out.push('anonymized')
  // Der Stummel einer Zusammenführung trägt nur noch eine alte Rechnung. Schriebe
  // man ihm, bekäme derselbe Mensch die Mail zweimal.
  if (guest.merged_into) out.push('merged')
  // Ein Sperrvermerk ist der ausdrückliche Wunsch des Betriebs, mit diesem Gast
  // nichts mehr zu tun zu haben. Ihm Werbung zu schicken wäre das Gegenteil.
  if (guest.blacklisted) out.push('blacklisted')
  if (!(guest.email ?? '').includes('@')) out.push('no_email')
  // Der Widerspruch überlebt ein versehentlich neu gesetztes Häkchen: er steht in
  // einer eigenen Spalte und wird hier eigenständig geprüft.
  if (guest.marketing_unsubscribed_at) out.push('unsubscribed')
  if (!guest.marketing_consent) out.push('no_consent')

  return out
}

export function mayReceiveMarketing(guest: MarketingProfile): boolean {
  return marketingBlocks(guest).length === 0
}

/**
 * Frühestens wieder nach so vielen Tagen dieselbe Art Werbung an denselben Gast.
 *
 * Ein Geburtstagsgruß ist einmal im Jahr; 300 Tage lassen einen verschobenen Termin
 * zu und verhindern trotzdem, dass ein zweiter Klick zwei Mails erzeugt. Dieselbe
 * Schwelle prüft der Server noch einmal gegen den Postausgang — die Oberfläche kann
 * sich irren, der Postausgang nicht.
 */
export const MIN_DAYS_BETWEEN_SENDS = 300

/**
 * Wann zuletzt eine Werbemail dieser Art an diesen Gast ging — und ob das reicht.
 * `sentDates` kommt aus dem Postausgang und ist damit die einzige Quelle; ein
 * Zählerfeld am Gast wäre wieder eine gespeicherte Zahl, die auseinanderläuft.
 */
export function sentTooRecently(
  sentDates: ISODate[], today: ISODate, minDays = MIN_DAYS_BETWEEN_SENDS,
): boolean {
  return sentDates.some((d) => nights(d, today) < minDays)
}

/* ────────────────────────────────────────────────────────── Textvorlagen */

export interface MarketingTemplate {
  subject: string
  /** Mehrere Absätze, durch Leerzeilen getrennt. */
  body: string
}

/**
 * Die Platzhalter, die eine Vorlage kennt. Bewusst wenige und bewusst englisch
 * benannt wie in `mailTemplates.ts`, damit dort dieselbe `fill`-Mechanik greift.
 *
 * Ein Platzhalter, für den es keinen Wert gibt, wird zu einer leeren Zeichenkette —
 * NICHT stehen gelassen. „Liebe {first_name}" in einer echten Mail ist der Fehler,
 * an den sich der Gast erinnert.
 */
export interface MarketingVars {
  /** Vor- und Nachname, oder die Firma. */
  name: string
  first_name: string
  /** Der Betrieb, so wie er als Absender erscheint. */
  tenant: string
  /** Nur Geburtstag: das Alter, das der Gast erreicht. */
  turning: string
  /** Nur Wiederkehr: das Jahr des letzten Aufenthalts und die Einheit. */
  year: string
  unit: string
}

export const MARKETING_PLACEHOLDERS: (keyof MarketingVars)[] = [
  'name', 'first_name', 'tenant', 'turning', 'year', 'unit',
]

/**
 * Die Vorgabetexte stehen in `mailTemplates.ts` und nicht hier.
 *
 * Nicht aus Bequemlichkeit: jene Datei wird wortgleich neben die Edge Function
 * gelegt (`npm run mail:sync`), weil Deno nicht in `src/` greifen kann. Stünde der
 * Text hier, gäbe es ihn zweimal — einmal für die Vorschau im Browser und einmal für
 * den Versand auf dem Server — und die beiden liefen auseinander, sobald jemand einen
 * Satz ändert. Der Gast bekäme dann etwas anderes zu lesen, als der Vermieter vorher
 * gesehen hat.
 */
export function defaultTemplate(kind: MarketingKind, lang: MailLang): MarketingTemplate {
  return defaultMarketingTemplate(templateKind(kind) as MailKind, lang)
}

/**
 * Setzt die Platzhalter ein. Unbekannte Platzhalter bleiben stehen — sie sind ein
 * Tippfehler des Betriebs und sollen in der Vorschau AUFFALLEN; bekannte ohne Wert
 * verschwinden, weil dort schlicht nichts zu sagen ist.
 */
export function fillTemplate(text: string, vars: Partial<MarketingVars>): string {
  return text.replace(/\{(\w+)\}/g, (whole, key: string) => {
    if (!(MARKETING_PLACEHOLDERS as string[]).includes(key)) return whole
    return (vars as Record<string, string | undefined>)[key] ?? ''
  })
}

/** Der Schlüssel, unter dem die Vorlage in `templates` liegt. */
export function templateKind(kind: MarketingKind): string {
  return kind === 'birthday' ? 'marketing_birthday' : 'marketing_return'
}
